<template>
    <div class="m-timeline-area" >
      <div class="m-timeline">
        <div
          :class="['m-timeline-item', {'last': index === timelineDesc.length - 1}]"
          v-for="(desc, index) in timelineDesc"
          :key="index">
          <div class="u-tail"></div>
          <div class="u-dot"></div>
          <div class="u-content">
            <div style="font-weight: 600;color: #FF9800;font-size: 16px;"  v-if="type == 0">{{desc.training_time}}</div>
            <div style="font-weight: 600;color: #FF9800;font-size: 16px;"  v-else>{{desc.training_time + " " + desc.training_item_limit[0] + "-" + desc.training_item_limit[1]}}</div>
            <div class="mt-2" v-if="type == 1" style="font-size: 14px;color: #666;">培訓地點：{{ desc.training_place }}</div>
            <div class="mt-2" style="font-size: 14px;color: #666;">{{ desc.training_information }}</div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
import Item from '@/views/details/item.vue';

  export default {
    name: 'Timeline',
    props: {
      timelineDesc: { // 时间轴内容数组
        type: Array,
        default: () => {
          return [] 
        }
      },
      width: { // 时间轴区域总宽度
        type: Number,
        default: 360
      },
      type: {
        type: String,
        default: '0'
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .m-timeline-area {
    // margin: 0 auto;
    .m-timeline {
      .m-timeline-item {
        position: relative;
        padding-bottom: 30px;
        .u-tail {
          position: absolute;
          top: 10px;
          left: 5px;
          height: calc(100% - 10px);
        //   border-left: 2px solid #e8e8e8; // 实线
          // border-left: 2px dotted #e8e8e8; // 点线
          border-left: 2px dashed #FFD672; // 虚线
        }
        .u-dot {
          position: absolute;
          width: 12px;
          height: 12px;
          border: 2px solid #FFD672;
          border-radius: 50%;
          background: #FFD672;
        }
        .u-content {
          position: relative;
          top: -6px;
          margin-left: 25px;
          word-break: break-all;
          word-wrap: break-word;
          line-height: 24px;
          background-color: #FFFAF0;
          border-radius: var(--border-radius);
          padding: 15px 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          
        }
      }
      .last {
        .u-tail {
          display: none;
        }
      }
    }
  }
  </style>
  